import { krishnaWall, mahadevOnWall, garageWall, wallSplash } from "../assets";

export const items = [
  {
    imgSrc: krishnaWall,
    id: 1,
  },
  {
    imgSrc: mahadevOnWall,
    id: 2,
  },
  {
    imgSrc: garageWall,
    id: 2,
  },
  {
    imgSrc: wallSplash,
    id: 2,
  },
  {
    imgSrc: "https://source.unsplash.com/featured/?lamp",
    id: 2,
  },
  {
    imgSrc: "https://source.unsplash.com/featured/?vase",
    id: 2,
  },
];
